import { PAGINATION } from '@/constants/pagination.constant';
import { MessageType } from '@/types/common';
import { createAppSlice } from '../createAppSlice';
import { transformerArray } from '../transformer';
import { Message } from '@/enums/message.enum';
import { MESSAGE } from '@/constants/message.constant';

type ImportHistorySliceState = {
  loading: boolean;
  listImportHistory: ImportHistory[];
  importHistoryDetail?: ImportHistory;
  message?: MessageType;
  pagination: Pagination;
};

const initialState: ImportHistorySliceState = {
  loading: false,
  listImportHistory: [],
  importHistoryDetail: undefined,
  pagination: PAGINATION,
  message: undefined
};

export const importHistorySlice = createAppSlice({
  name: 'importHistory',
  initialState,
  reducers: (create) => ({
    getImportHistoryList: create.asyncThunk(
      async ({
        offset,
        limit,
        type
      }: {
        offset: number;
        limit: number;
        type: string;
      }) => {
        const response = await apiFetcher.post(
          `history-import/filter?offset=${offset}&limit=${limit}`,
          {
            type
          }
        );
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.listImportHistory = transformerArray(action.payload.listData);
          state.pagination = action.payload.paging;
        },
        rejected: (state) => {
          state.loading = false;
          state.listImportHistory = [];
          state.pagination = PAGINATION;
          state.message = {
            type: Message.ERROR,
            message:
              MESSAGE.FETCH_FAIL || 'Lấy danh sách lịch sử nhập liệu thất bại!'
          };
        }
      }
    ),

    getImportHistoryDetail: create.asyncThunk(
      async (id: number) => {
        const response = await apiFetcher.get(`history-import/${id}`);
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.importHistoryDetail = action.payload;
        },
        rejected: (state) => {
          state.loading = false;
          state.importHistoryDetail = undefined;
          state.message = {
            type: Message.ERROR,
            message:
              MESSAGE.FETCH_FAIL || 'Lấy chi tiết lịch sử nhập liệu thất bại!'
          };
        }
      }
    ),

    // Action để reset message
    resetMessages: create.reducer((state) => {
      state.message = undefined;
    })
  }),
  selectors: {
    watchImportHistoryList: (state) => state.listImportHistory,
    watchImportHistoryDetail: (state) => state.importHistoryDetail,
    watchImportHistoryLoading: (state) => state.loading,
    watchImportHistoryMessage: (state) => state.message,
    watchImportHistoryPagination: (state) => state.pagination
  }
});

export const {
  watchImportHistoryList,
  watchImportHistoryDetail,
  watchImportHistoryLoading,
  watchImportHistoryMessage,
  watchImportHistoryPagination
} = importHistorySlice.selectors;

export const { getImportHistoryList, getImportHistoryDetail, resetMessages } =
  importHistorySlice.actions;
